/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { llmVectorStoresCreateFileBatch } from "../../funcs/llmVectorStoresCreateFileBatch.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: operations.CreateVectorStoreFileBatchRequest$inboundSchema,
};

export const tool$llmVectorStoresCreateFileBatch: ToolDefinition<typeof args> =
  {
    name: "llm-vector-stores-create-file-batch",
    description: `Batch add multiple files to vector store

Adds multiple files to a vector store in a single batch operation.`,
    args,
    tool: async (client, args, ctx) => {
      const [result, apiCall] = await llmVectorStoresCreateFileBatch(
        client,
        args.request,
        { fetchOptions: { signal: ctx.signal } },
      ).$inspect();

      if (!result.ok) {
        return {
          content: [{ type: "text", text: result.error.message }],
          isError: true,
        };
      }

      const value = result.value;

      return formatResult(value, apiCall);
    },
  };
